export default __webpack_public_path__ + "static/media/6 1.676f2450.svg";